export default __webpack_public_path__ + "static/media/route.591a257f.svg";